module.exports = __webpack_public_path__ + "img/gwbjl_bg.30ebfdc3.jpg";